<template>
  <div>
    <van-popup v- v-model="show" get-container="#app">
      <div class="Modal">
        <div class="title">提示</div>
        <div class="classCapacity">
          {{ value }}
        </div>
        <div class="determine">
          <div
            class="determineLeft"
            v-if="Isclose"
            @click="determine('Isclose')"
          >
            取消
          </div>
          <div @click="determine">确定</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'SeftPopup',
  data() {
    return {
      show: false,
    };
  },
  props: {
    value: String,
    Isclose: Boolean,
  },
  watch: {
    value: {
      handler(val) {
        if (val !== '') {
          this.show = true;
        } else {
          this.show = false;
        }
      },
      immediate: true,
    },
    show: {
      handler(val) {
        if (!val) {
          this.$emit('input', '');
        }
      },
      immediate: true,
    },
  },
  methods: {
    determine(val) {
      if (val === 'Isclose') {
        this.show = false;
      } else {
        if (this.$listeners.define !== undefined) {
          this.$emit('define', {
            cb: () => {
              this.show = false;
            },
            value: this.value,
          });
          return;
        }
        this.show = false;
      }
    },
  },
};
</script>
<style scoped>
.Modal {
  min-height: 207px;
  background: #fff;
  border-radius: 12px;
}
.determine {
  display: flex;
  width: 100%;
  height: 56px;
  color:  #F65249;
  font-weight: 700;
  font-size: 13px;
  line-height: 56px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.determine div {
  flex: 1;
}
.title {
  width: 100%;
  height: 56px;
  font-size: 14px;
  font-weight: 700;
  line-height: 56px;
  color: rgba(80, 80, 80, 1);
}
.classCapacity {
  min-height: 60px;
  padding: 12px 10px;
  color: rgba(80, 80, 80, 1);
  font-size: 13px;
  text-align: center;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-popup {
  width: 85%;
  border-radius: 12px !important;
}
.determineLeft {
  color: rgba(80, 80, 80, 1);
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
